import { render, staticRenderFns } from "./incomeAnalysis.vue?vue&type=template&id=27dd4fa8&scoped=true"
import script from "./incomeAnalysis.vue?vue&type=script&lang=js"
export * from "./incomeAnalysis.vue?vue&type=script&lang=js"
import style0 from "./incomeAnalysis.vue?vue&type=style&index=0&id=27dd4fa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27dd4fa8",
  null
  
)

export default component.exports